module.exports = __webpack_public_path__ + "img/couponDoctor_d.4175a6a2.png";